import React, { useState } from "react";
import axios from "axios";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
//import Link from "@mui/material/Link";
//import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import { Visibility, VisibilityOff } from "@mui/icons-material";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [estatus, setEstatus] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    axios
      .post("https://boxerlogistica.com/api/login.php", {
        email: email,
        password: password,
      })
      .then((response) => {
        console.log(response);
        setEstatus(response.data.status);
        if (response.data.status === "successAdmin") {
          sessionStorage.setItem("loggedIn", true);
          //sessionStorage.setItem("email", true);
          sessionStorage.setItem(
            "userData",
            JSON.stringify(response.data.data)
          );

          window.location.href = "/dashboardAdmin";
        } else if (response.data.status === "successAdminItalika") {
          sessionStorage.setItem("loggedIn", true);
          //sessionStorage.setItem("email", true);
          sessionStorage.setItem(
            "userData",
            JSON.stringify(response.data.data)
          );

          window.location.href = "/dashboardAdminItalika";
        } else if (response.data.status === "successUserItalika") {
          sessionStorage.setItem("loggedIn", true);
          //sessionStorage.setItem("email", true);
          sessionStorage.setItem(
            "userData",
            JSON.stringify(response.data.data)
          );
           window.location.href = "/dashboardItalika";
        } else if (response.data.status === "successUser") {
          sessionStorage.setItem("loggedIn", true);
          //sessionStorage.setItem("email", true);
          sessionStorage.setItem(
            "userData",
            JSON.stringify(response.data.data)
          );
           window.location.href = "/dashboard";
        } else if (response.data.status === "successUserAdmin") {
          sessionStorage.setItem("loggedIn", true);
          //sessionStorage.setItem("email", true);
          sessionStorage.setItem(
            "userData",
            JSON.stringify(response.data.data)
          );
          window.location.href = "/dashboard";
        } else {
          setError(response.data.message);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "2%",
      }}
    >
      
      <div class="Inicio-container">
              <div class="div-left_Inicio">
                <ul class="footer">
                  <li>
                  <Container maxWidth="sm">
                  <form onSubmit={handleSubmit}>
                    {error && (
                      <Alert style={{ marginBottom: "20px" }} severity="error">
                        {error}{estatus}
                      </Alert>
                    )}
                    <img src="/images/Logoboxerlogistica.png" alt="Boxer Logistica Home Page"></img>
                    <br></br><br></br>
                    <b>Iniciar sesión</b>
                    <br></br><br></br>
                    Correo electrónico*
                    <TextField
                      type="email"
                      value={email}
                      onChange={handleEmailChange}
                      variant="filled"
                      id="email"
                      //label="Usuario"
                      fullWidth
                      style={{ marginBottom: "20px" }}
                    />
                    Ingresa tu contraseña*
                    <TextField
                      type={showPassword ? "text" : "password"}
                      value={password}
                      onChange={handlePasswordChange}
                      variant="filled"
                      id="password"
                      //label="Contraseña"
                      autoComplete="current-password"
                      fullWidth
                      style={{ marginBottom: "20px" }}
                      InputProps={{
                        endAdornment: (
                          <IconButton onClick={handleShowPassword}>
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        ),
                      }}
                    />
                    <Button variant="contained" type="submit">
                      Iniciar
                    </Button>
                  </form>
                  </Container>
                  </li>
                </ul>
              </div>
              <div class="div-right_Inicio">
                <ul class="footer">
                  <li>
                    <img src="/images/Inicio2.png" alt="Boxer Logistica"></img>
                  </li>
                </ul>
              </div>
            </div>
    </Box>
  );
}

export default Login;


/*

<p>
            Don't have an account? <Link href="/register">Sign up</Link>
          </p>
          
function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    axios
      .post("http://boxerlogistica.com/api/login.php", {
        email: email,
        password: password,
      })
      .then((response) => {
        console.log(response);
        if (response.data.status === "success") {
          sessionStorage.setItem("loggedIn", true);
          sessionStorage.setItem(
            "userData",
            JSON.stringify(response.data.data)
          );

          window.location.href = "/dashboard";
        } else {
          setError(response.data.message);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "5%",
      }}
    >
      <Container maxWidth="sm">
        <form onSubmit={handleSubmit}>
          <Typography
            style={{ marginBottom: "20px" }}
            variant="h2"
            component="h2"
          >
            Mi Cuenta
          </Typography>
          {error && (
            <Alert style={{ marginBottom: "20px" }} severity="error">
              {error}
            </Alert>
          )}
          <TextField
            type="email"
            value={email}
            onChange={handleEmailChange}
            variant="filled"
            id="email"
            label="Usuario"
            fullWidth
            style={{ marginBottom: "20px" }}
          />
          <TextField
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={handlePasswordChange}
            variant="filled"
            id="password"
            label="Contraseña"
            fullWidth
            style={{ marginBottom: "20px" }}
            InputProps={{
              endAdornment: (
                <IconButton onClick={handleShowPassword}>
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              ),
            }}
          />
          <Button variant="contained" type="submit">
            Ingresar
          </Button>
        </form>
      </Container>
    </Box>
  );
}

export default Login;

*/
